import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-satisfaction-satisfactions-card',
  templateUrl: './satisfaction-satisfactions-card.component.html',
  styleUrls: ['./satisfaction-satisfactions-card.component.scss']
})
export class SatisfactionSatisfactionsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  counter: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('satisfaction-satisfactions-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('satisfaction-satisfactions-spinner');
      this.showCounter = true;
      this.counter = this.data.length;
    } else if ('-' === this.data) {
      this.counter = '-';
      this.showCounter = true;
      this.spinnerService.hide('satisfaction-satisfactions-spinner');
    }
  }
}

